'use strict'

template = require '../vVERSION.html.mustache'
module.exports = do ->
  init: ->
    return unless (@$el = $('#ls-in-app-messages')).length
    @fetch()

  fetch: ->
    c = Cookie.get('c')?.replace(/"/g, '') # We save the c cookie enclosed in quotes. Remove them before the Ajax call.
    categoryId = document.head.getAttribute('data-categoryid')
    data = {
      division_id: Groupon?.division?.id
      page: 1
      per_page: 1
      consumer_id: c if c
      app_name: document.head.getAttribute('data-app')
      locale: document.head.getAttribute('data-locale')
      category_id: categoryId if categoryId
    }

    if Groupon.PageFlags?.isTouchRequest
      data.device_id = 'ITIER-DEVICE_ID'

    if Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']
      data.viewport = $(window).width()

    $.ajax {
      type: "GET"
      url: Groupon.endpoints?.in_app_messages or '/in_app_messages'
      data
      success: (res) =>
        if res?.id?
          blocked = @getBlockedMessageIds()
          @id = res.id.toString()
          unless @id in blocked
            @$el.html template.render {res}
            @attachDismissListener()
        else
          Groupon.Utils.trackEvent 'iam-no-message-id'
      error: ->
        Groupon.Utils.trackEvent 'iam-call-failed'
    }

  getBlockedMessageIds: ->
    value = Cookie.get('msg_hide')
    if value then value.split "," else []

  setBlockedMessageIds: (blocked) ->
    # keep last 20 blocked campaigns, if we hit 20, remove the
    # least recently blocked campaign (first in the list)
    if (blocked.length > 20)
      blocked.shift()
    value = blocked.join(",")
    Cookie.set('msg_hide', value)

  blockMessage: (message_id) ->
    blocked = @getBlockedMessageIds()
    unless message_id in blocked
      blocked.push(message_id)
      @setBlockedMessageIds(blocked)

  attachDismissListener: ->
    @$el.find('.hide-link').attr('aria-label', Groupon.LS.translations?.ax?.close or 'close')
    .one 'click', (event) =>
      event.preventDefault()
      @$el.addClass('hide')
      if @id > 0
        @blockMessage(@id)



// WEBPACK FOOTER //
// ./modules/in_app_messages/frontend/main.coffee